// Styles here will override Bulma styles
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const styledCustomerContentSection = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const styledCustomerContentContainer = css`
  display: flex;

  ${media('<tablet')} {
    flex-direction: column;
    padding: 16px;
  }
`;

export const StyledHoverIcon = styled.svg`
  width: 18px;
  height: 18px;
  fill: #5b6987;
  :hover {
    fill: #0069ff;
  }
`;

export const StyledEmailHoverIcon = styled.svg`
  width: 18px;
  height: 18px;
  margin-top: 2px;
  fill: #5b6987;
  :hover {
    fill: #0069ff;
  }
`;

export const styledCustomerContentStickyMenu = css`
  background: #f3f5f9;
  position: sticky;
  width: 25%;
  align-self: flex-start;
  top: 130px;
  margin-bottom: 16px;

  p {
    margin: 0;
  }

  ${media('<tablet')} {
    position: inherit;
    width: 100%;
  }
`;

export const styledCustomerContentCard = css`
  img {
    margin: 0px !important;
  }
`;

export const styledCustomerContentText = css`
  padding-right: 64px;
  max-width: 860px;
  color: #031b4e;
  ${media('<tablet')} {
    padding: 0px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'WorkSans-Bold';
    font-weight: 400;
  }
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.3;
    margin: 3rem 0 0;
  }

  h1 {
    font-size: 2.4rem;
  }
  h2 {
    font-size: 1.7rem;
  }
  h3 {
    font-size: 1.3rem;
  }
  img {
    max-width: 100%;
  }
  ul {
    margin: 1.25rem 0 0;
    padding-left: 32px;
    color: #5b6987;
    font-size: 16px;
    line-height: 160%;
    font-weight: 400;
  }
  li {
    margin: 0.25rem 0;
  }
  a {
    color: #0069ff;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    font-family: 'WorkSans-Regular';
    font-weight: normal;
  }

  iframe {
    width: 100%;
    min-height: 500px;
  }
`;

export const styledCustomerDetails = css`
  padding: 20px;
`;

export const styledCustomerDetailsItem = css`
  margin-bottom: 16px;
`;

export const styledCustomerDetailsTerm = css`
  text-transform: uppercase;
  color: #010e28;
  font-size: 14px;
  font-family: 'WorkSans-Medium';
`;

export const styledCustomerDetailsName = css`
  color: #5b6987;
  margin-left: 0;
  font-size: 16px;
`;

export const styledCustomerProductsName = css`
  color: #5b6987;
  margin-left: 0;
  font-size: 16px;

  a {
    color: #0069ff;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    font-family: 'WorkSans-Regular';
    font-weight: normal;
    text-transform: capitalize;
  }
`;

export const styledCustomerContentBreadcrumbLink = css`
  color: #005fe6;
  text-decoration: none;
  font-family: 'WorkSans-Regular';
`;

export const styledCustomerSocialLink = css`
  cursor: pointer;
  margin: 5px;
`;

export const styledSocialInfo = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const styledCustomerSocialInfo = css`
  border-top: 1px solid #e5e8ed;
  padding: 20px 0;
`;

export const styledCustomerContentBreadcrumb = css`
  color: rgba(3, 27, 78, 0.7);
  ::before {
    color: rgba(3, 27, 78, 0.7);
    content: '›';
    margin-left: 8px;
    margin-right: 8px;
  }
`;

// custom card styles
export const styledCardBox = css`
  background: #f3f5f9;
  border-bottom: 1px solid #e5e8ed;
  border-radius: 5px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.5s ease;

  :hover {
    box-shadow: 0 10px 20px rgba(3, 27, 78, 0.1) !important;
    transform: scale(1.01);
  }
`;

export const styledCardContent = css`
  position: relative;
  height: 100%;

  img {
    max-width: 100%;
  }

  ${media('<= desktop')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const styledQuoteCard = css`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export const styledQuoteCardContent = css`
  position: relative;
  height: 100%;
  padding: 20px;
  .title {
    margin-top: 15px;
  }
  img {
    margin-bottom: 10px;
  }
  ${media('<= desktop')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
